import isObject from 'lodash/isObject';

export default fields => {
    const watch = {};

    const methods = {
        filterInputErrors(inputErrorType) {
            if (this.errorType[inputErrorType]) {
                // eslint-disable-next-line max-len
                this.errors = this.errors.filter(error => !this.ERRORS_TYPES[inputErrorType].includes(error));

                if (this.errors.length === 0) {
                    this.error = false;
                }
            }
        },
    };

    Object.entries(fields).forEach(([propName, propValue]) => {
        // eslint-disable-next-line func-names
        watch[propName] = function (newValue) {
            let inputErrorTypes = [propValue];

            if (isObject(propValue)) {
                const skipFiltering = newValue === '' && propValue.resetProgrammatically;

                if (skipFiltering) {
                    return;
                }

                const { errorTypes } = propValue;

                inputErrorTypes = Array.isArray(errorTypes) ? errorTypes : [errorTypes];
            }

            if (Array.isArray(propValue)) {
                inputErrorTypes = propValue;
            }

            inputErrorTypes.forEach(errorTypeName => {
                this.filterInputErrors(errorTypeName);
            });
        };
    });

    return { methods, watch };
};
